import { ChangeDetectorRef, Component } from '@angular/core';
import { Type } from 'class-transformer';
import { ArrayHelpers } from '../../../../helpers/array.helpers';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { VariablesNodeInformation } from '../../../../models/basic/formulaEditor.model';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { ContainerFieldEditDialog } from '../../../../settings/datamodel/dialogs/container.field.edit.dialog';
import { DataCheck, FormulaWorkflowDialogContent } from '../../../workflow.dialog';
import { DefaultValueSettings } from '../../containeroperations/default.definition.control';

@Component({
    selector: 'wf-checknull-settings',
    templateUrl: './checknull.settings.html'
})
export class CheckNullSettings extends FormulaWorkflowDialogContent {
    DSColumns = [];
    Defaults: DefaultValueSettings = null;

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'checkNullWFModule';
        reg.Caption = '@@Null-Werte befuellen';
        reg.GroupID = 'reldataoperations';
        reg.Index = 105;
        reg.SettingsControl = CheckNullSettings;
        reg.SettingsTypeHelper = new CheckNullSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private cdRef: ChangeDetectorRef) {
        super();
    }

    initialize(data: any) {
        super.initialize(data);
        let dataColumns = [];
        if (data) {
            const dataVal = ClassTransformerHelper.CopyObject(data, CheckNullSettingsData);
            this.Defaults = dataVal.Defaults;
            if (dataVal.Columns) {
                dataColumns = dataVal.Columns; 
            }
        }
        const dataSource = this.ActualState.get('DataSource');
        if (dataSource && dataSource.Columns) {
            if (dataColumns.length == 0) {
                dataSource.Columns.forEach((x: any) => {
                    const valType = ContainerFieldEditDialog.AllTypes.find(y => y.Value == x.DataTyp);
                    this.DSColumns.push({
                        DataTyp: x.DataTyp,
                        Caption: x.Name + ' (' + (valType?.Caption ?? x.DataTyp) + ')',
                        ColumnName: x.Name,
                        SetDefault: true,
                        CanCheckEmpty: x.DataTyp == 'System.String'
                    });
                    const vni = new VariablesNodeInformation();
                    vni.Name = x.Name;
                    this.Variables.push(vni);
                });
            } else {
                dataSource.Columns.forEach((x: any) => {
                    const valType = ContainerFieldEditDialog.AllTypes.find(y => y.Value == x.DataTyp);
                    const col = dataColumns.find((dc: any) => dc.ColumnName == x.Name);
                    if (col) {
                        this.DSColumns.push({
                            DataTyp: x.DataTyp,
                            Caption: x.TranslatedCaption + ' (' + (valType?.Caption ?? x.DataTyp) + ')',
                            ColumnName: col.ColumnName,
                            SetDefault: col.SetDefault,
                            Formula: col.Formula,
                            CheckEmpty: col.CheckEmpty,
                            CanCheckEmpty: x.DataTyp == 'System.String'
                        });
                    } else {
                        this.DSColumns.push({
                            DataTyp: x.DataTyp,
                            Caption: x.TranslatedCaption + ' (' + (valType?.Caption ?? x.DataType) + ')',
                            ColumnName: x.Name,
                            CanCheckEmpty: x.DataTyp == 'System.String'
                        });
                    }
                    const vni = new VariablesNodeInformation();
                    vni.Name = x.Name;
                    this.Variables.push(vni);
                });
            }
            ArrayHelpers.sortAlphabetical(this.Variables, 'Name');
            this.fillDefaults();
        }
    }

    fillDefaults() {
        const settings = this.Defaults ?? new DefaultValueSettings();
        const defObj = settings.getDefaultObject();
        this.DSColumns.forEach(x => {
            x.DefaultVal = defObj[x.DataTyp];
        });
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        if (!this.DSColumns.some(col => col.SetDefault || col.Formula)) {
            retVal.IsCorrect = false;
            retVal.Error = '@@Bitte waehlen Sie mindestens eine Spalte aus';
        }
        return retVal;
    }

    getResult(): any {
        const retVal = new CheckNullSettingsData();
        retVal.Defaults = this.Defaults;
        this.DSColumns.forEach(col => {
            if (col.SetDefault || col.Formula) {
                retVal.Columns.push({
                    ColumnName: col.ColumnName,
                    SetDefault: col.SetDefault,
                    Formula: col.Formula,
                    CheckEmpty: col.CheckEmpty
                });
            }
        });
        return retVal;
    }

    checkAll(event: any) {
        if (event) {
            this.DSColumns.forEach(x => {
                x.SetDefault = event.checked;
            });
            this.cdRef.detectChanges();
        }
    }
}

export class CheckNullColumnSetting {
    ColumnName: string;
    Formula: string;
    CheckEmpty = false;
    SetDefault = true;
}

// @dynamic
export class CheckNullSettingsData {
    @Type(() => CheckNullColumnSetting)
    Columns: CheckNullColumnSetting[] = [];
    @Type(() => DefaultValueSettings)
    Defaults: DefaultValueSettings;
}

export class CheckNullSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        const retVal = new WorkflowExitInfo();
        retVal.Type = 'relData';
        return [retVal];
    }
    getEntryPoints(): WorkflowExitInfo[] {
        const retVal = new WorkflowExitInfo();
        retVal.Type = 'relData';
        return [retVal];
    }
    getEmptySettingsInstance() {
        return new CheckNullSettingsData();
    }
}
